import type { OriginalSizeSingle } from '@shared/ui/list/types';
import { formatNumber } from '@shared/utils/number';

export const buildOriginalSizeParam = (originalSizes: OriginalSizeSingle[], units: string | null = 'cm'): string => {
  const originalSizesToNumbers = originalSizes
    .map((originalSize) => (originalSize ? formatNumber(+originalSize) : ''))
    .filter(Number)
    .join(`${units} x `);
  return originalSizesToNumbers.length ? originalSizesToNumbers + `${units}` : '';
};
